<template>
  <div class="lottery-page winner-page">
    <div class="winner-page__inner">
      <div class="winner-hero">
        <p class="winner-hero__label">
          {{
            $store.state.language === 'en'
              ? 'Winning Number'
              : 'ပေါက်ဂဏန်း'
          }}
        </p>
        <p class="winner-hero__number">{{ lastNumber }}</p>
        <p class="winner-hero__congrats">
          {{
            $store.state.language === 'en'
              ? 'Congratulations to all winners!'
              : 'ထီပေါက်သူများ အားလုံးပဲ ဂုဏ်ယူပါတယ်'
          }}
        </p>
      </div>

      <div class="winner-podium">
        <!-- 2nd -->
        <div class="winner-card winner-card--second">
          <div class="winner-card__rank">2</div>
          <div class="winner-card__avatar winner-card__avatar--sm">
            <img
              src="https://myanmarhot2d.com/static/media/default_profile.f06fefecd2a84cdc7274.jpg"
              alt=""
            >
          </div>
          <p class="winner-card__name">
            {{ winnerList[1] ? winnerList[1].name : '-' }}
          </p>
          <div class="winner-card__row">
            <span>Bet</span>
            <strong>{{ winnerList[1] ? Number(winnerList[1].bet).toLocaleString() : '-' }}</strong>
          </div>
          <div class="winner-card__row">
            <span>Win</span>
            <strong class="winner-card__win">{{ winnerList[1] ? Number(winnerList[1].won).toLocaleString() : '-' }}</strong>
          </div>
        </div>

        <!-- 1st -->
        <div class="winner-card winner-card--first">
          <div class="winner-card__rank winner-card__rank--gold">1</div>
          <div class="winner-card__avatar winner-card__avatar--lg">
            <img
              src="https://myanmarhot2d.com/static/media/default_profile.f06fefecd2a84cdc7274.jpg"
              alt=""
            >
          </div>
          <p class="winner-card__name">
            {{ winnerList[0] ? winnerList[0].name : '-' }}
          </p>
          <div class="winner-card__row">
            <span>Bet</span>
            <strong>{{ winnerList[0] ? Number(winnerList[0].bet).toLocaleString() : '-' }}</strong>
          </div>
          <div class="winner-card__row">
            <span>Win</span>
            <strong class="winner-card__win">{{ winnerList[0] ? Number(winnerList[0].won).toLocaleString() : '-' }}</strong>
          </div>
        </div>

        <!-- 3rd -->
        <div class="winner-card winner-card--third">
          <div class="winner-card__rank">3</div>
          <div class="winner-card__avatar winner-card__avatar--sm">
            <img
              src="https://myanmarhot2d.com/static/media/default_profile.f06fefecd2a84cdc7274.jpg"
              alt=""
            >
          </div>
          <p class="winner-card__name">
            {{ winnerList[2] ? winnerList[2].name : '-' }}
          </p>
          <div class="winner-card__row">
            <span>Bet</span>
            <strong>{{ winnerList[2] ? Number(winnerList[2].bet).toLocaleString() : '-' }}</strong>
          </div>
          <div class="winner-card__row">
            <span>Win</span>
            <strong class="winner-card__win">{{ winnerList[2] ? Number(winnerList[2].won).toLocaleString() : '-' }}</strong>
          </div>
        </div>
      </div>

      <div class="winner-table-wrap">
        <table class="winner-table">
          <thead>
            <tr>
              <th>{{ $store.state.language === 'en' ? 'Name' : 'အမည်' }}</th>
              <th>{{ $store.state.language === 'en' ? 'Bet Amount' : 'ထိုးငွေ' }}</th>
              <th>{{ $store.state.language === 'en' ? 'Won Amount' : 'ပေါက်ငွေ' }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(user, index) in winnerList"
              v-show="index > 2"
              :key="index"
            >
              <td>{{ user.name }}</td>
              <td>{{ Number(user.bet).toLocaleString() }} MMK</td>
              <td>{{ Number(user.won).toLocaleString() }} MMK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      winnerList: [],
      lastNumber: '-',
    };
  },
  methods: {
    async fetchWinnerList() {
      try {
        const res = await axios.get('/2d/winnerlist');
        this.winnerList = res.data.data;
        this.lastNumber = res.data.lastNumber;
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fetchWinnerList();
  },
};
</script>

<style scoped>
.winner-page {
  background: #FFFFFF;
  min-height: 100%;
  padding-bottom: 7rem;
}

.winner-page__inner {
  padding: 1rem 0.85rem 2rem;
}

.winner-hero {
  background: linear-gradient(160deg, #0D3B1A 0%, #145224 100%);
  border-radius: 16px;
  padding: 1.5rem 1rem 1.35rem;
  text-align: center;
  box-shadow: 0 8px 24px rgba(8, 38, 18, 0.16);
}

.winner-hero__label {
  margin: 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.winner-hero__number {
  margin: 0.35rem 0 0.5rem;
  color: #E8B923;
  font-size: 4.5rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.04em;
}

.winner-hero__congrats {
  margin: 0;
  color: #FFFFFF;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
}

.winner-podium {
  display: grid;
  grid-template-columns: 1fr 1.15fr 1fr;
  gap: 0.55rem;
  align-items: end;
  margin-top: 1.15rem;
}

.winner-card {
  position: relative;
  background: #FFFFFF;
  border: 1.5px solid rgba(13, 59, 26, 0.16);
  border-radius: 14px;
  padding: 1.35rem 0.55rem 0.85rem;
  text-align: center;
  box-shadow: 0 4px 14px rgba(8, 38, 18, 0.07);
}

.winner-card--first {
  border-color: #E8B923;
  box-shadow: 0 8px 22px rgba(232, 185, 35, 0.22);
  padding-top: 1.55rem;
  padding-bottom: 1rem;
}

.winner-card__rank {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #0D3B1A;
  color: #FFFFFF;
  font-size: 0.75rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.winner-card__rank--gold {
  background: #E8B923;
  color: #0D3B1A;
  width: 28px;
  height: 28px;
  font-size: 0.85rem;
}

.winner-card__avatar {
  margin: 0 auto 0.55rem;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #0D3B1A;
  background: #F5F7F5;
}

.winner-card--first .winner-card__avatar {
  border-color: #E8B923;
}

.winner-card__avatar--sm {
  width: 48px;
  height: 48px;
}

.winner-card__avatar--lg {
  width: 64px;
  height: 64px;
}

.winner-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.winner-card__name {
  margin: 0 0 0.55rem;
  color: #0D3B1A;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}

.winner-card__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.3rem;
  padding: 0.2rem 0.15rem;
  color: #4A6354;
  font-size: 0.72rem;
  font-weight: 600;
}

.winner-card__row strong {
  color: #0D3B1A;
  font-size: 0.75rem;
}

.winner-card__win {
  color: #145224 !important;
}

.winner-table-wrap {
  margin-top: 1.25rem;
  border: 1.5px solid rgba(13, 59, 26, 0.16);
  border-radius: 14px;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0 4px 14px rgba(8, 38, 18, 0.06);
}

.winner-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
}

.winner-table th,
.winner-table td {
  padding: 0.75rem 0.7rem !important;
  border: none !important;
  font-weight: 500 !important;
  text-align: left;
}

.winner-table thead th {
  background: #0D3B1A;
  color: #FFFFFF !important;
  font-size: 0.8rem;
  font-weight: 700 !important;
}

.winner-table tbody {
  color: #0D3B1A;
}

.winner-table tbody tr:nth-child(even) {
  background: #F5F7F5;
}

.winner-table tbody tr:hover {
  background: #E5EBE6;
}

.winner-table tbody td {
  font-size: 0.82rem;
}

@media (max-width: 380px) {
  .winner-hero__number {
    font-size: 3.6rem;
  }

  .winner-card__name {
    font-size: 0.75rem;
  }

  .winner-card__row {
    font-size: 0.68rem;
  }
}
</style>
